export class PaymentMethodTypeConstants {
    public static Credit_Card = 'Credit Card';
    public static eCheck = 'eCheck';
    public static Money_Order = 'Money Order';
    public static Wave = 'Wave';
    public static Orange_Money = 'Orange_Money';
    public static Paypal = 'PayPal';
    public static Cash ='Cash';
    public static Cash_On_Delivery = 'Cash On Delivery';
    public static Bank_Transfer ='Bank Transfer';
    public static Ach ='Ach';
    public static Bonus_Check='Bonus Check';
    public static Personal_Check='Personal Check';
    public static Travelers_Check='Traveler’s Check';
    public static BanContact_MisterCash_and_Maestro='BanContact MisterCash & Maestro';
    public static MisterCash_and_Maestro='MisterCash & Maestro';
    public static Service_Order = 'Service Order';
    public static Single_Debit = 'Single Debit';
    public static Direct_Debit = 'Direct Debit';
    public static Ideal = 'Ideal';
    public static Pay_By_Link = 'Pay By Link';
    public static Credit_Card_External = 'Credit Card External';
    public static Wire_Transfer='Wire Transfer';
    public static Eps='EPS';
    public static Giro_Pay='GiroPay';
    public static SingleDebit = 'Single_Debit';
    public static DirectDebit = 'Direct_Debit';
    public static Blik = 'BLIK';
    public static Integrated_Terminal_Adyen = 'Integrated Terminal (Adyen)';
    public static Vipps = 'Vipps';
    public static Trustly = 'Trustly';
    public static Google_Pay = 'Google Pay';
    public static Apple_Pay = 'Apple Pay';
    public static Walley = 'Walley';
    public static Twint = 'TWINT';
    public static ApplePay_Adyen = 'Apple Pay Adyen';
    public static Dori_Pay = 'DoriPay';
    public static Riverty = 'Riverty';
    public static GooglePay_Adyen = 'Google Pay Adyen';
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/payment-method-types.constants.ts